// export const foodymanDocMenu = [
//   {
//     name: "Introduction",
//     routerPath: "/foodyman-documentation/introduction",
//   },
//   {
//     name: "Prerequisite",
//     dropDownItems: [
//       {
//         name: "Basic",
//         routerPath: "/foodyman-documentation/basic",
//       },
//       {
//         name: "Backend",
//         routerPath: "/foodyman-documentation/server",
//       },
//       {
//         name: "Frontend",
//         routerPath: "/foodyman-documentation/front",
//       },
//       {
//         name: "Recommendations",
//         routerPath: "/foodyman-documentation/recommendations",
//       },
//       {
//         name: "Mobile app",
//         routerPath: "/foodyman-documentation/mobile-app",
//       },
//     ],
//   },
//   {
//     name: "Local environment Setup",
//     dropDownItems: [
//       {
//         name: "Mobile app",
//         routerPath: "/foodyman-documentation/flutter-sdk",
//       },
//       {
//         name: "Frontend",
//         routerPath: "/foodyman-documentation/local-front",
//       },
//       {
//         name: "Backend",
//         routerPath: "/foodyman-documentation/local-server",
//       },
//     ],
//   },
//   {
//     name: "Backend",
//     dropDownItems: [
//       {
//         name: "Install on server",
//         routerPath: "/foodyman-documentation/mandatory-setup-backend",
//       },
//       {
//         name: "Troubleshooting",
//         routerPath: "/foodyman-documentation/troubleshooting-backend",
//       },
//     ],
//   },
//   {
//     name: "Admin Panel",
//     dropDownItems: [
//       {
//         name: "Install on server",
//         routerPath: "/foodyman-documentation/install-on-server",
//       },
//       {
//         name: "Mandatory setup",
//         routerPath: "/foodyman-documentation/mandatory-setup",
//       },
//       {
//         name: "Customization",
//         routerPath: "/foodyman-documentation/customization",
//       },
//       {
//         name: "Troubleshooting",
//         routerPath: "/foodyman-documentation/troubleshooting-admin",
//       },
//     ],
//   },
//   {
//     name: "Web App",
//     dropDownItems: [
//       {
//         name: "Mandatory setup",
//         routerPath: "/foodyman-documentation/mandatory-setup-web",
//       },
//       {
//         name: `Build code and setup on server`,
//         routerPath: "/foodyman-documentation/build-code-and-setup-on-server",
//       },
//     ],
//   },

//   {
//     name: "Customer Apps",
//     dropDownItems: [
//       {
//         name: "Mandatory setup",
//         routerPath: "/foodyman-documentation/mandatory-setup-customer",
//       },
//       {
//         name: "Customization",
//         routerPath: "/foodyman-documentation/customization-customer",
//       },
//       {
//         name: "App build & release",
//         routerPath: "/foodyman-documentation/customer-app-build-release",
//       },
//     ],
//   },

//   {
//     name: "Vendor Apps",
//     dropDownItems: [
//       {
//         name: "Mandatory setup",
//         routerPath: "/foodyman-documentation/mandatory-setup-vendor",
//       },
//       {
//         name: "Customization",
//         routerPath: "/foodyman-documentation/customization-vendor",
//       },
//       {
//         name: "App build & release",
//         routerPath: "/foodyman-documentation/vendor-app-build-release",
//       },
//     ],
//   },
//   {
//     name: "Deliveryboy Apps",
//     dropDownItems: [
//       {
//         name: "Mandatory setup",
//         routerPath: "/foodyman-documentation/mandatory-setup-deliveryboy",
//       },
//       {
//         name: "Customization",
//         routerPath: "/foodyman-documentation/customization-deliveryboy",
//       },
//       {
//         name: "App build & release",
//         routerPath: "/foodyman-documentation/deliveryboy-app-build-release",
//       },
//     ],
//   },
//   {
//     name: "POS system",
//     dropDownItems: [
//       {
//         name: "Mandatory setup",
//         routerPath: "/foodyman-documentation/mandatory-setup-pos",
//       },
//       {
//         name: "Customization",
//         routerPath: "/foodyman-documentation/customization-pos",
//       },
//       {
//         name: "App build & release",
//         routerPath: "/foodyman-documentation/pos-app-build-release",
//       },
//     ],
//   },
//   {
//     name: "Firebase setup",
//     routerPath: "/foodyman-documentation/firebase",
//   },
//   {
//     name: "Update",
//     dropDownItems: [
//       {
//         name: "Admin Panel",
//         routerPath: "/foodyman-documentation/update-admin-panel",
//       },
//       {
//         name: "App & Web",
//         routerPath: "/foodyman-documentation/Update-app-web",
//       },
//     ],
//   },
//   {
//     name: "Support plan",
//     routerPath: "/foodyman-documentation/support-plan",
//   },
// ];

export const foodymanDocMenu = [
  {
    name: "Introduction",
    dropDownItems: [
      {
        name: "Introduction",
        routerPath: "/foodyman-documentation/introduction",
      },
      {
        name: "Server requirements",
        routerPath: "/foodyman-documentation/recommendations",
      },
    ],
  },
  {
    name: "Backend Api",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/server",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-backend",
      },
      {
        name: "Payment installation",
        routerPath: "/foodyman-documentation/payment-installation",
      },
      {
        name: "Image settings",
        routerPath: "/foodyman-documentation/image-settings",
      },
      {
        name: "Troubleshooting",
        routerPath: "/foodyman-documentation/troubleshooting-backend",
      },
    ],
  },
  {
    name: "Admin Panel",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/admin",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/install-on-server",
      },
      {
        name: "Troubleshooting",
        routerPath: "/foodyman-documentation/troubleshooting-admin",
      },
    ],
  },
  {
    name: "Customer Website",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/front",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-web",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Qrcode Website",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/front-qr",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-web-qr",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Customer App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/mobile-app",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-customer",
      },
      {
        name: "Customization",
        routerPath: "/foodyman-documentation/customization-customer",
      },
      {
        name: "App build & release",
        routerPath: "/foodyman-documentation/customer-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Vendor App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/vendor-app",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-vendor",
      },
      {
        name: "Customization",
        routerPath: "/foodyman-documentation/customization-vendor",
      },
      {
        name: "App build & release",
        routerPath: "/foodyman-documentation/vendor-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Driver App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/driver-app",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-deliveryboy",
      },
      {
        name: "Customization",
        routerPath: "/foodyman-documentation/customization-deliveryboy",
      },
      {
        name: "App build & release",
        routerPath: "/foodyman-documentation/deliveryboy-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Pos App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/pos-app",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-pos",
      },
      {
        name: "Customization",
        routerPath: "/foodyman-documentation/customization-pos",
      },
      {
        name: "App build & release",
        routerPath: "/foodyman-documentation/pos-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Kiosk App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/foodyman-documentation/kiosk-app",
      },
      {
        name: "Installation",
        routerPath: "/foodyman-documentation/mandatory-setup-kiosk",
      },
      {
        name: "Customization",
        routerPath: "/foodyman-documentation/customization-kiosk",
      },
      {
        name: "App build & release",
        routerPath: "/foodyman-documentation/kiosk-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  // {
  //   name: "QR code App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/foodyman-documentation/qr-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/foodyman-documentation/install-qrcode",
  //     }
  //   ],
  // },
  {
    name: "Google services setup",
    routerPath: "/foodyman-documentation/google-services",
  },
  {
    name: "Update",
    routerPath: "/foodyman-documentation/update",
  },
];
